import * as R from 'ramda';
import Log from '../common/logging';
import { defaultConfiguration } from './defaultConfig';

const issuerDidPath = ['issuance', 'providers', 'web', 'credentialsIssuerDid'];
const prodIssuerDid = 'did:sol:idvGDSP8P4Fa7qWUnMS1n4HDmD2hbpUY4JrvqtatrVy';
const updatedDefaultNetworkConfigsWithProdIssuer = (originalConfig = defaultConfiguration.flowConfigs) => {
  const updatedConfig = R.clone(defaultConfiguration);
  R.forEachObjIndexed((value, key) => {
    const existingIssuerValue = R.path(issuerDidPath, value);
    const prodIssuerValue = R.assocPath(issuerDidPath, prodIssuerDid, value);
    const retObj = existingIssuerValue ? prodIssuerValue : value;
    Log.debug(`${key} using ${R.path(issuerDidPath, retObj)}`);
    updatedConfig.flowConfigs[key] = retObj;
  }, originalConfig);
  return updatedConfig.flowConfigs;
};
export default updatedDefaultNetworkConfigsWithProdIssuer;

/**
 * if the user is not signing, there is never a reason not to ask for POWO
 * if they are signing, then we can skip POWO if authenticationDisabled is true
 * @param ownerSigns
 * @param authenticationDisabled
 * @returns
 */
export const shouldAuthenticate = (ownerSigns: boolean, authenticationDisabled?: boolean) =>
  !ownerSigns || !authenticationDisabled;
